import { useFormContext, Controller } from "react-hook-form";
import dayjs from "dayjs";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useTranslate } from "react-admin";

const AvailabilityDateAndTimes = ({ disabled }: { disabled: boolean }) => {
  const translate = useTranslate();
  const form = useFormContext();
  const formErrors = form.formState.errors;

  const locationTimezone = form.watch("location.timezone") || "UTC";

  return (
    <div className="availabilityDateAndTimes">
      <Controller
        name="start_date"
        control={form.control}
        defaultValue={form.getValues("start_date") || null}
        render={({ field }) => (
          <DatePicker
            {...field}
            value={field.value ? dayjs(field.value).tz(locationTimezone) : null}
            onChange={(value) => field.onChange(value)}
            label={translate("availability.date") + "*"}
            disabled={disabled}
            format="MM.DD.YYYY"
            sx={{
              width: "100%"
            }}
          />
        )}
      />
      <Controller
        name="start_time"
        control={form.control}
        defaultValue={form.getValues("start_time") || null}
        render={({ field }) => (
          <TimePicker
            {...field}
            value={field.value ? dayjs(field.value).tz(locationTimezone) : null}
            onChange={(value) => {
              field.onChange(value);
              form.clearErrors("end");
            }}
            label={translate("availability.start") + "*"}
            disabled={disabled}
            ampmInClock
            ampm={true}
            skipDisabled
            sx={{
              width: "100%"
            }}
          />
        )}
      />
      <Controller
        name="end_time"
        control={form.control}
        defaultValue={form.getValues("end_time") || null}
        render={({ field }) => (
          <TimePicker
            {...field}
            value={field.value ? dayjs(field.value).tz(locationTimezone) : null}
            onChange={(value) => {
              field.onChange(value);
              form.clearErrors("end");
            }}
            label={translate("availability.end") + "*"}
            disabled={disabled}
            ampmInClock
            ampm={true}
            skipDisabled
            sx={{
              width: "100%"
            }}
            slotProps={{
              textField: {
                // @ts-ignore
                error: !!formErrors?.end?.message?.message,
                // @ts-ignore
                helperText: formErrors?.end?.message?.message
                  ? // @ts-ignore
                    formErrors?.end?.message?.message
                  : ""
              }
            }}
          />
        )}
      />
    </div>
  );
};

export default AvailabilityDateAndTimes;
